module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.lensType), function(ld) {
    return _c('div', {
      staticClass: "col-sm center order-div"
    }, [_c('label', {
      staticClass: "g-mb-0 g-font-size-20"
    }, [_vm._v(_vm._s(ld.description))]), _vm._v(" "), _c('div', {
      staticClass: "image-div g-mb-10",
      on: {
        "click": function($event) {
          return _vm.JobTypeDependency(ld)
        }
      }
    }, [(_vm.Order.LensTypeCode != ld.lensCode) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": ld.imageURL
      }
    }) : _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": ld.invertedImageURL
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.LensTypeCode),
        expression: "Order.LensTypeCode"
      }],
      attrs: {
        "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
        "type": "radio",
        "name": "lensType"
      },
      domProps: {
        "value": ld.lensCode,
        "checked": _vm._q(_vm.Order.LensTypeCode, ld.lensCode)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.Order, "LensTypeCode", ld.lensCode)
        }, function($event) {
          return _vm.JobTypeDependency(ld)
        }]
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.ValidationResult.OrderLensTypeCode) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.ValidationResult.OrderLensTypeCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensTypeCode))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('div', {
    staticClass: " hide-overflow"
  }, [_c('table', {
    staticClass: "table table-borderless white-smoke-bg"
  }, [_c('thead', [_c('tr', {
    staticClass: "center"
  }, [_c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Sphere"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Axis"), (((_vm.Order.ReCyl != null || _vm.Order.LeCyl != null) && (_vm.Order.ReCyl != '0.00' && _vm.Order.LeCyl != '0.00')) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Addition"), (_vm.Order.LensTypeCode == 'BFF' && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Seg. Height"), (_vm.Order.LensTypeCode == 'BFF' && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "center"
  }, [_vm._m(7), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRESph
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "-20",
      "maxSize": "20",
      "stepSize": "0.25",
      "fixedSize": "2",
      "displayPlus": "true"
    },
    model: {
      value: (_vm.Order.ReSph),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReSph", $$v)
      },
      expression: "Order.ReSph"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRESph) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRESph))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "-10",
      "maxSize": "10",
      "stepSize": "0.25",
      "fixedSize": "2",
      "defaultNegative": "true",
      "inputName": "ReCyl"
    },
    model: {
      value: (_vm.Order.ReCyl),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReCyl", $$v)
      },
      expression: "Order.ReCyl"
    }
  })], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREAxis
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0",
      "maxSize": "180",
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.ReAxis),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReAxis", $$v)
      },
      expression: "Order.ReAxis"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREAxis) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREAxis))]) : _vm._e()], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREAdd
    },
    attrs: {
      "minSize": "0",
      "maxSize": "5",
      "stepSize": "0.25",
      "displayPlus": "true",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.ReAdd),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReAdd", $$v)
      },
      expression: "Order.ReAdd"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREAdd) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREAdd))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRESegHeight
    },
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "stepSize": "1",
      "fixedSize": "0",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.ReSegHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReSegHeight", $$v)
      },
      expression: "Order.ReSegHeight"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRESegHeight) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRESegHeight))]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "center"
  }, [_vm._m(8), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLESph
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "-30",
      "maxSize": "30",
      "stepSize": "0.25",
      "fixedSize": "2",
      "displayPlus": "true"
    },
    model: {
      value: (_vm.Order.LeSph),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeSph", $$v)
      },
      expression: "Order.LeSph"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLESph) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLESph))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "-10",
      "maxSize": "10",
      "stepSize": "0.25",
      "fixedSize": "2",
      "defaultNegative": "true",
      "inputName": "LeCyl"
    },
    model: {
      value: (_vm.Order.LeCyl),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeCyl", $$v)
      },
      expression: "Order.LeCyl"
    }
  })], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEAxis
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0",
      "maxSize": "180",
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.LeAxis),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeAxis", $$v)
      },
      expression: "Order.LeAxis"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEAxis) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEAxis))]) : _vm._e()], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEAdd
    },
    attrs: {
      "minSize": "0",
      "maxSize": "5",
      "stepSize": "0.25",
      "displayPlus": "true",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.LeAdd),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeAdd", $$v)
      },
      expression: "Order.LeAdd"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEAdd) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEAdd))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLESegHeight
    },
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "stepSize": "1",
      "fixedSize": "0",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.LeSegHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeSegHeight", $$v)
      },
      expression: "Order.LeSegHeight"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLESegHeight) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLESegHeight))]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [((_vm.Order.LeCyl > 0 && _vm.Order.ReCyl < 0) || (_vm.Order.LeCyl < 0 && _vm.Order.ReCyl > 0)) ? _c('p', [_c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("You have entered opposite values for left and right eye cylinder. Please confirm Rx.")])]) : _vm._e(), _vm._v(" "), ((_vm.Order.LeSph > 0 && _vm.Order.ReSph < 0) || (_vm.Order.LeSph < 0 && _vm.Order.ReSph > 0)) ? _c('p', [_c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("You have entered opposite values for left and right eye sphere. Please confirm Rx.")])]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLensStock),
      expression: "showLensStock"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsUsingStockLensLab),
      expression: "Order.IsUsingStockLensLab"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsUsingStockLensLab) ? _vm._i(_vm.Order.IsUsingStockLensLab, null) > -1 : (_vm.Order.IsUsingStockLensLab)
    },
    on: {
      "click": function($event) {
        return _vm.ShowAdditionalFields(_vm.Order.IncludeAdditionalRxFields)
      },
      "change": function($event) {
        var $$a = _vm.Order.IsUsingStockLensLab,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsUsingStockLensLab", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsUsingStockLensLab", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsUsingStockLensLab", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("Use Stock lens")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IncludeAdditionalRxFields),
      expression: "Order.IncludeAdditionalRxFields"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IncludeAdditionalRxFields) ? _vm._i(_vm.Order.IncludeAdditionalRxFields, null) > -1 : (_vm.Order.IncludeAdditionalRxFields)
    },
    on: {
      "click": function($event) {
        return _vm.ShowAdditionalFields(_vm.Order.IncludeAdditionalRxFields)
      },
      "change": function($event) {
        var $$a = _vm.Order.IncludeAdditionalRxFields,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("Show Additonal Rx fields.")]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('div', {
    staticClass: " hide-overflow"
  }, [_c('table', {
    staticClass: "table table-borderless white-smoke-bg"
  }, [_c('thead', [_c('tr', {
    staticClass: "center"
  }, [_c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Base "), (((_vm.Order.REHorizontalPrismValue > 0 || _vm.Order.LEHorizontalPrismValue > 0)) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('th'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Base "), ((_vm.Order.REVerticalPrismValue > 0 || _vm.Order.LEVerticalPrismValue > 0) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('th'), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "center"
  }, [_vm._m(15), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": "0.25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.REHorizontalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REHorizontalPrismValue", $$v)
      },
      expression: "Order.REHorizontalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.REHorizontalPrismDirection),
      expression: "Order.REHorizontalPrismDirection"
    }],
    staticClass: "form-control",
    class: {
      error_select: _vm.ValidationResult.OrderREHorizontalPrismDirection
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "REHorizontalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderREHorizontalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREHorizontalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": ".25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.REVerticalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REVerticalPrismValue", $$v)
      },
      expression: "Order.REVerticalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.REVerticalPrismDirection),
      expression: "Order.REVerticalPrismDirection"
    }],
    staticClass: "form-control order-div",
    class: {
      error_select: _vm.ValidationResult.OrderREVerticalPrismDirection
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "REVerticalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderREVerticalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "disabled": _vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.REOCHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REOCHeight", $$v)
      },
      expression: "Order.REOCHeight"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "center"
  }, [_vm._m(16), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": "0.25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.LEHorizontalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEHorizontalPrismValue", $$v)
      },
      expression: "Order.LEHorizontalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LEHorizontalPrismDirection),
      expression: "Order.LEHorizontalPrismDirection"
    }],
    staticClass: "form-control",
    class: {
      error_select: _vm.ValidationResult.OrderLEHorizontalPrismDirection
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "LEHorizontalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderLEHorizontalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEHorizontalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": ".25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.LEVerticalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEVerticalPrismValue", $$v)
      },
      expression: "Order.LEVerticalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LEVerticalPrismDirection),
      expression: "Order.LEVerticalPrismDirection"
    }],
    staticClass: "form-control order-div",
    class: {
      error_select: _vm.ValidationResult.OrderLEVerticalPrismDirection
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "LEVerticalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderLEVerticalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "disabled": _vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.LEOCHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEOCHeight", $$v)
      },
      expression: "Order.LEOCHeight"
    }
  })], 1)])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Distance PD"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), (!_vm.Order.IsOnly1DistancePD) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREDistPD
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "1"
    },
    model: {
      value: (_vm.Order.ReDistPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReDistPD", $$v)
      },
      expression: "Order.ReDistPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREDistPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREDistPD))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEDistPD
    },
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "1"
    },
    model: {
      value: (_vm.Order.LeDistPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeDistPD", $$v)
      },
      expression: "Order.LeDistPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEDistPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEDistPD))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Order.IsOnly1DistancePD) ? _c('div', {
    staticClass: "form-group"
  }, [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderDistancePD
    },
    attrs: {
      "minSize": "40",
      "maxSize": "80",
      "stepSize": ".50",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.DistancePD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "DistancePD", $$v)
      },
      expression: "Order.DistancePD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderDistancePD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderDistancePD))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsOnly1DistancePD),
      expression: "Order.IsOnly1DistancePD"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "type": "checkbox",
      "tabindex": "-500"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsOnly1DistancePD) ? _vm._i(_vm.Order.IsOnly1DistancePD, null) > -1 : (_vm.Order.IsOnly1DistancePD)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsOnly1DistancePD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsOnly1DistancePD", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsOnly1DistancePD", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsOnly1DistancePD", $$c)
        }
      }, _vm.ClearDistancePD]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Only 1 PD Measurement")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Near PD"), (_vm.Order.LensTypeCode == 'BFF') ? _c('span', [_vm._v("*")]) : (_vm.Order.DoesNotMeetRequirements) ? _c('span') : _vm._e()]), _vm._m(18), _vm._v(" "), (!_vm.Order.IsOnly1NearPD) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRENearPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.ReNearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReNearPD", $$v)
      },
      expression: "Order.ReNearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRENearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRENearPD))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLENearPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO'
    },
    model: {
      value: (_vm.Order.LeNearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeNearPD", $$v)
      },
      expression: "Order.LeNearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLENearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLENearPD))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Order.IsOnly1NearPD) ? _c('div', {
    staticClass: "form-group"
  }, [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderNearPD
    },
    attrs: {
      "minSize": "40",
      "maxSize": "80",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.NearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "NearPD", $$v)
      },
      expression: "Order.NearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderNearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderNearPD))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsOnly1NearPD),
      expression: "Order.IsOnly1NearPD"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.Order.LensType.isFocal || _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "tabindex": "-500"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsOnly1NearPD) ? _vm._i(_vm.Order.IsOnly1NearPD, null) > -1 : (_vm.Order.IsOnly1NearPD)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsOnly1NearPD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsOnly1NearPD", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsOnly1NearPD", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsOnly1NearPD", $$c)
        }
      }, _vm.ClearNearPD]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Only 1 PD Measurement")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Lens Design"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.isLensDesignLoadingx) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderLensDesign
    },
    attrs: {
      "label": "designName",
      "disabled": _vm.ComputedIsLensDesignDisabled || _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "options": _vm.lensDesign,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " ",
      "preselect-first": true
    },
    on: {
      "remove": function($event) {
        return _vm.RemoveLensDesign()
      },
      "close": function($event) {
        return _vm.LensDesignDependency(_vm.Order.LensDesignObject.designCode, _vm.Order.LensMaterialObject.code)
      }
    },
    model: {
      value: (_vm.Order.LensDesignObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LensDesignObject", $$v)
      },
      expression: "Order.LensDesignObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderLensDesign) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensDesign))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div order-div"
  }, [_c('label', [_vm._v("Lens Material"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(19)]), _vm._v(" "), (_vm.isLensMaterialLoadingx) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLensDesignLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderLensMaterial
    },
    attrs: {
      "label": "name",
      "disabled": _vm.lensMaterial.length == 0 || _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "options": _vm.lensMaterial,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "remove": function($event) {
        return _vm.RemoveMaterial()
      },
      "input": function($event) {
        return _vm.LensMaterialDependency(_vm.Order.LensDesignObject.designCode, _vm.Order.LensMaterialObject.code)
      }
    },
    model: {
      value: (_vm.Order.LensMaterialObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LensMaterialObject", $$v)
      },
      expression: "Order.LensMaterialObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderLensMaterial) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensMaterial))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [(_vm.MasterAccountType != 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div left-padding-div",
    class: {
      disable: _vm.Order.LensDesign == null
    }
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n                    Lens Treatment(s)\n                ")]), _vm._v(" "), (_vm.isLensMaterialLoading || _vm.isCompatibleLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lensTreatment), function(lt) {
    return _c('div', {
      staticClass: "form-check"
    }, [_c('span', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.LensTreatment),
        expression: "Order.LensTreatment"
      }],
      staticClass: "form-check-input",
      attrs: {
        "disabled": _vm.isCompatibleLoading,
        "type": "checkbox"
      },
      domProps: {
        "value": lt.code,
        "checked": Array.isArray(_vm.Order.LensTreatment) ? _vm._i(_vm.Order.LensTreatment, lt.code) > -1 : (_vm.Order.LensTreatment)
      },
      on: {
        "click": function($event) {
          return _vm.GetCompatability(lt.code)
        },
        "change": function($event) {
          var $$a = _vm.Order.LensTreatment,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = lt.code,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Order, "LensTreatment", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Order, "LensTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Order, "LensTreatment", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-order"
    }, [_vm._v(_vm._s(lt.description))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div"
  }, [_c('label', [_vm._v("Lens Treatment(s)")]), _vm._v(" "), (_vm.isLensMaterialLoading || _vm.isCompatibleLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "label": "description",
      "track-by": "code",
      "options": _vm.lensTreatment,
      "disabled": _vm.isCompatibleLoading,
      "hideSelected": true,
      "multiple": true,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "remove": _vm.RemoveLensTreatment,
      "select": _vm.AddLensTreatment
    },
    model: {
      value: (_vm.selectedLensTreatment),
      callback: function($$v) {
        _vm.selectedLensTreatment = $$v
      },
      expression: "selectedLensTreatment"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div"
  }) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lens Treatment Comments")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LensTreatmentComment),
      expression: "Order.LensTreatmentComment"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.LensTreatmentComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "LensTreatmentComment", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div g-px-10"
  }, [_c('span', {
    staticClass: "form-label div-spacing-bottom"
  }, [_vm._v("\n                    Special Requests/Instructions\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.DoesNotMeetRequirements),
      expression: "Order.DoesNotMeetRequirements"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.DoesNotMeetRequirements) ? _vm._i(_vm.Order.DoesNotMeetRequirements, null) > -1 : (_vm.Order.DoesNotMeetRequirements)
    },
    on: {
      "click": function($event) {
        return _vm.SpecialOrder(_vm.Order.DoesNotMeetRequirements)
      },
      "change": function($event) {
        var $$a = _vm.Order.DoesNotMeetRequirements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "DoesNotMeetRequirements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "DoesNotMeetRequirements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "DoesNotMeetRequirements", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("The lens options above do not meet the medical needs of this patient.")]), _vm._v(" "), _vm._m(20)])]), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.SpecialInstructions1),
      expression: "Order.SpecialInstructions1"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "What is the special request and why is it needed?",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.Order.SpecialInstructions1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "SpecialInstructions1", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('p', {
    staticClass: "font-order"
  }, [_vm._v("\n                    Special orders will be reviewed by the OneSight EssilorLuxottica Foundation support team in order to approve or decline the request. Special orders will take extra time to process due to this review\n                ")]) : _vm._e(), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsSpecialOrderNecessary),
      expression: "Order.IsSpecialOrderNecessary"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsSpecialOrderNecessary) ? _vm._i(_vm.Order.IsSpecialOrderNecessary, "") > -1 : (_vm.Order.IsSpecialOrderNecessary)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsSpecialOrderNecessary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("I attest that this special order request is medically necessary for the patient.*")])]), _vm._v(" "), (_vm.ValidationResult.OrderIsSpecialOrderNecessary) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderIsSpecialOrderNecessary))]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Order Information\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          If the lens options do not meet the needs of the patient, please complete as much of the order form as possible and check the box below to include additional information in the section for special requests.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div"
  }, [_c('p', {
    staticClass: "left-padding-div"
  }, [_vm._v("Please select the lens type from the icons below.*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "SPH (Sphere) - Spherical error, or overall power of lens is the basic part of the prescription. Sometimes, the doctor may write 'PL' or 'Plano' - In this case, select +0.00",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Cylinder "), _c('span', {
    attrs: {
      "data-balloon": "CYL (Cylinder) - Cylinder power indicates correction for astigmatism. This field will default to a negative cylinder power. Plus cylinder can be ordered by adding a + sign before the power. Sometimes, the doctor may write 'Sphere' or 'Sph' in this field. In this case, leave the cylinder and axis fields blank.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Axis - The axis is required for prescriptions with cylinder power. This tells the orientation of the astigmatism.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "ADD (Addition) - If your prescription contains ADD or Addition values, this indicates that the patient requires a bifocal lens. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Segment (Seg) Height - This is the vertical measurement in millimeters from the bottom of the lens to where the top of the addition power should begin. This field is only necessary for multifocal (bifocal or progressive) lenses. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes. If the prescription contains an Addition (ADD) but does not contain a height measurement it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank. ",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Right Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(RE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Left Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(LE or OS)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Show fields for Prism and Optical Center.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Horiz. Prism "), _c('span', {
    attrs: {
      "data-balloon": "Horizontal Prism - This is the amount of prismatic power, measured in prism diopters.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear).",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Vert. Prism "), _c('span', {
    attrs: {
      "data-balloon": "Vertical Prism - This is the amount of prismatic power, measured in prism diopters.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear).",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    OC Height "), _c('span', {
    attrs: {
      "data-balloon": "Optical/Ocular Center height - Please note, this option is not available for multifocal orders. If necessary, provide more information in the Special Requests section",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Right Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(RE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Left Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(LE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "Distance PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects in the distance. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils).",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "Near PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects close to their face. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils). If the prescription contains an Addition (ADD) but does not contain Near PD measurements it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "All standard lenses provided are polycarbonate",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "If the above options do not meet the medical needs of the patient, a special request can be made by clicking this check box and completing the special request fields.  All special requests are subject to approval.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f0f0d94a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0f0d94a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/OrderInformation.vue
// module id = 563
// module chunks = 3